export default __webpack_public_path__ + "static/media/Blue-lagoon.fe479ef1.webp";